<template>
  <div class="app-container">
    <el-tabs type="border-card" @tab-click="clickTab">
      <el-tab-pane label="血压检测">
        <component :is="currentView1" :pInfo="pInfo"></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import bloodPressureList from "./bloodPressureList.vue";

export default {
  components: {bloodPressureList},
  props: {
    pInfo: {
      typeof: Object,
      default: null
    }
  },
  data() {
    return {
      currentView1: "bloodPressureList",

    };
  },
  created() {},
  methods:{
    clickTab(targetName){
      console.log(targetName);
      // if(targetName.label == "血压") {
      //   this.update1 = false;
      //   this.update2 = true;
      // } else {
      //   this.update1 = true;
      //   this.update2 = false;
      // }
    }
  }
};
</script>

<style>
</style>
